
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselTypeMilitaryFilled as ObiVesselTypeMilitaryFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-type-military-filled.js';
 
 
 

 
 export const ObiVesselTypeMilitaryFilled = createComponent({
   react: React,
   tagName: 'obi-vessel-type-military-filled',
   elementClass: ObiVesselTypeMilitaryFilledElement,
   events: {
     
   }
  });
 
 